<template>
  <a-modal
    centered
    :title="title"
    :width="1000"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
   <div class="table-page-search-wrapper">
      <a-form class="div-query-banner" layout="inline" @keyup.enter.native="searchQuery">
        <a-form-item label="地址">
              <j-input placeholder="请输入地址" v-model="queryParam.ip"></j-input>
            </a-form-item>
            <a-form-item label="系统类型">
              <j-dict-select-tag
                dictCode="bus_server_sys_type"
                placeholder="请选择系统类型"
                v-model="queryParam.sysType"
              ></j-dict-select-tag>
            </a-form-item>
            <template v-if="toggleSearchStatus">
              <a-form-item label="备注">
                <a-input placeholder="请输入备注" v-model="queryParam.remarks"></a-input>
              </a-form-item>
            </template>
        <a-button class="query-banner-btn" type="primary" @click="searchQuery" icon="search">查询</a-button>
        <a-button  class="query-banner-btn" type="primary" @click="searchReset" icon="reload" >重置</a-button>
        <a @click="handleToggleSearch">
          {{ toggleSearchStatus ? '收起' : '展开' }}
          <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
        </a>
      </a-form>
    </div>
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
      </a-table>
    </div>
  </a-modal>
</template>


<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JInput from '@/components/jeecg/JInput.vue'
export default {
  components: {
    JInput
  },
    mixins:[JeecgListMixin],
    props: {
      title: {
        type: String,
        default: "选择服务器"
      },
      appId: {
        type: String,
        default: ""
      }
    },
    data() {
    return {
      visible: false,
      /* 排序参数 */
      isorter: {
          column: 'sort',
          order: 'asc',
        },
      columns: [
      {
          title: '排序',
          align: 'center',
          dataIndex: 'sort',
        },
        {
          title: 'ip地址',
          align: 'center',
          dataIndex: 'ip',
        },
        {
          title: '系统类型',
          align: 'center',
          dataIndex: 'sysType',
        },
        {
          title: '启用',
          align: 'center',
          dataIndex: 'izActivity',
          scopedSlots: {
            customRender: 'izActivity',
          },
        },
      ],
      url: {
        list: '/servermanage/busServermanageServers/list',
      },
    }
  },
  methods: {
    open(){
      this.initData();
      this.visible=true;
    },
    handleOk(){
      this.$emit("select",this.selectedRowKeys);
      this.visible=false;
    },
    handleCancel(){
      this.visible=false
    },
    initData() {
      this.onClearSelected();
      this.searchReset();
    }
  },
}
</script>

<style lang="less" scoped>
  @import '~@assets/less/common.less';
  .div-query-banner{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    &>*:nth-child(n){
      width:200px
    }
    &>*:nth-child(n+2){
      margin-left: 12px;
    }
    &>.query-banner-btn:nth-child(n){
      width:100px
    }
  }
</style>